export type AiModel = 'llama' | 'gpt' | 'balanced'

export const DEFAULT_AI_MODEL: AiModel = 'balanced'
